import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChecklistRevisionPage } from '@/components/checklist/ChecklistRevisionDialog';

const ChecklistRevision: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const sistemaId = params.get('sistemaId') || '';
  const sistemaTipo = params.get('sistemaTipo') || '';
  const clienteId = params.get('clienteId') || '';
  const clienteNombre = params.get('clienteNombre') || '';
  const checklistId = params.get('checklistId') || undefined;
  const returnTo = params.get('returnTo') || '/sistemas-cliente';

  if (!sistemaId || !sistemaTipo || !clienteId) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <p className="text-sm text-muted-foreground">Faltan parámetros para abrir la revisión.</p>
      </div>
    );
  }

  return (
    <ChecklistRevisionPage
      sistemaId={sistemaId}
      sistemaTipo={sistemaTipo}
      clienteId={clienteId}
      clienteNombre={clienteNombre}
      checklistId={checklistId}
      onClose={() => navigate(returnTo)}
    />
  );
};

export default ChecklistRevision;
